// =============================================================================
// firebase-config.js – Firebase Configuration
// =============================================================================
// In production (Vite build): reads API key from environment variable.
// In development: uses the env var from .env.local (loaded by Vite).
// Fallback: hardcoded value for non-Vite contexts (e.g., tests, direct file:// usage).
// =============================================================================

const apiKey =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_FIREBASE_API_KEY) ||
  (typeof process !== "undefined" && process.env?.VITE_FIREBASE_API_KEY) ||
  "";

export const firebaseConfig = {
  apiKey,
  authDomain: "trasporti-busto-proj.firebaseapp.com",
  projectId: "trasporti-busto-proj",
  storageBucket: "trasporti-busto-proj.firebasestorage.app",
  messagingSenderId: "1061930969785",
  appId: "1:1061930969785:web:d391bb0cac468b76fc0968",
  measurementId: "G-VKYKDRZ0YQ"
};
